module.exports = __webpack_public_path__ + "img/debate232.ee7294af.jpg";